import {computed, ref, Ref, unref, watch} from 'vue';
import haversineDistance from 'haversine-distance';

export const services = {
    certified: 'Dépôt/Vente chaussures de seconde main',
    manufactured: 'Vente chaussures reconditionnées',
    voucher: 'Utilisation des bons d’achat',
};
export const radii = [10 * 1000, 25 * 1000, 50 * 1000, 100 * 1000];
export const DEFAULT_MAP_CENTER = {lat: 46.98774725646568, lng: 2.0104980468750004};
export const DEFAULT_MAP_ZOOM = 6;

/** @type {Ref<Store[]>} */
export const stores = ref([]);
/** @type {Ref<?Store>} */
export const activeStore = ref(null);

// Search filters
/** @type {Ref<string[]>} */
export const activeServices = ref([]);
/** @type {Ref<number>} */
export const radius = ref(radii[0]);
/** @type {Ref<?Coordinates>} */
export const searchCoordinates = ref(null);
/** @type {Ref<boolean>} */
export const geolocated = ref(false);

/** @type {(function(Store): boolean)[]} */
const filters = [
    store => searchCoordinates.value ? radius.value >= store.distance : true,
    store => activeServices.value.length ? store.services.some(service => activeServices.value.includes(service)) : true,
];

export const filteredStores = computed(() => stores.value
    .map(store => {
        store.distance = searchCoordinates.value ? haversineDistance(store.coordinates, searchCoordinates.value) : null;
        return store;
    })
    .filter(store => filters.reduce((keep, filter) => keep && filter(store), true))
    .toSorted((storeA, storeB) => {
        if (storeA.distance !== null && storeB.distance !== null) {
            return storeA.distance - storeB.distance;
        }
        return 0;
    }),
);

watch(filteredStores, () => {
    activeStore.value = filteredStores.value.length === 1 ? filteredStores.value[0] : null;
});

/**
 * @param {Store} store
 * @returns {boolean}
 */
export function isActiveStore(store) {
    return activeStore.value === unref(store);
}

/**
 * @param {number} distance in meters
 * @returns {string} formatted distance in meters or kilometers with unit
 */
export function formatDistance(distance) {
    const lessThanKilometer = distance < 1000;
    const value = lessThanKilometer ? distance : distance / 1000;
    return value.toLocaleString(undefined, {
        style: 'unit',
        unit: lessThanKilometer ? 'meter' : 'kilometer',
        maximumFractionDigits: lessThanKilometer ? 0 : 1,
    });
}
